import APEmbed from './APEmbed';

export {
    APEmbed
};

export default APEmbed;